import React from "react";
import styles from "./AuthCardFooter.module.css";

/** Shared bottom of every auth card: HIPAA + SOC2 badge with Privacy/Terms links. */
const AuthCardFooter = () => {
  return (
    <div className={styles.footer}>
      <span className={styles.shield} aria-hidden="true">
        {/* HIPAA shield-check, Figma node 1791:24413 */}
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M6 11C6 11 10 9 10 6V2.5L6 1L2 2.5V6C2 9 6 11 6 11Z"
            stroke="#2F9E7A"
            strokeWidth="0.875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.5 6L5.5 7L7.5 5"
            stroke="#2F9E7A"
            strokeWidth="0.875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className={styles.compliance}>HIPAA-compliant</span>
      <span className={styles.dot}>&middot;</span>
      {/* New tab on purpose: someone mid-typing credentials must not lose
          the form (the shared auth layout would unmount it). */}
      <a
        className={styles.link}
        href="/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy
      </a>
      <span className={styles.dot}>&middot;</span>
      <a
        className={styles.link}
        href="/terms"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms
      </a>
    </div>
  );
};

export default AuthCardFooter;
